import React from 'react';
export function AgitationSection() {
  return <section className="bg-chocolate-50 py-20 px-4" data-id="element-1">
      <div className="max-w-3xl mx-auto space-y-12 text-lg md:text-xl text-chocolate-800 leading-relaxed" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-bold text-chocolate-900 text-center" data-id="element-3">
          ¿Te suena familiar?
        </h2>
        <div className="space-y-6" data-id="element-4">
          <p data-id="element-5">Son las 11 de la noche.</p>
          <p data-id="element-6">No tenés hambre. Pero algo en tu cabeza pide dulce.</p>

          <div className="pl-6 border-l-4 border-gold-400 italic space-y-2 py-2" data-id="element-7">
            <p data-id="element-8">"Si como, me arruino el día."</p>
            <p data-id="element-9">"Pero si no como, no duermo."</p>
          </div>

          <p data-id="element-10">Terminás comiendo. Terminás con culpa.</p>
          <p data-id="element-11">Y mañana empezás de nuevo.</p>
          <p className="font-bold text-chocolate-900" data-id="element-12">
            Eso no es una falla tuya. Es tu biología sin las herramientas
            correctas.
          </p>
        </div>

        <div className="w-full h-px bg-chocolate-800/20" data-id="element-13"></div>

        <div className="space-y-6" data-id="element-14">
          <p data-id="element-15">Ya lo intentaste todo:</p>

          <ul className="space-y-4 pl-4" data-id="element-16">
            <li className="flex items-center space-x-3" data-id="element-17">
              <span className="text-pain font-bold" data-id="element-18">→</span>
              <span data-id="element-19">Dieta sin azúcar (duró 9 días)</span>
            </li>
            <li className="flex items-center space-x-3" data-id="element-20">
              <span className="text-pain font-bold" data-id="element-21">→</span>
              <span data-id="element-22">Recetarios fit (ingredientes imposibles)</span>
            </li>
            <li className="flex items-center space-x-3" data-id="element-23">
              <span className="text-pain font-bold" data-id="element-24">→</span>
              <span data-id="element-25">Fuerza de voluntad (agotada a las 6pm)</span>
            </li>
          </ul>

          <p className="font-bold text-chocolate-900 text-xl md:text-2xl pt-4" data-id="element-26">
            El problema no sos vos. El problema es que ninguna solución fue
            diseñada para la mujer argentina.
          </p>
        </div>
      </div>
    </section>;
}